import React, { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { AddProjectrequirementAdminModal } from "../Modal";
import { ViewProjectrequirementadmin } from "./Salarytable";

const Requirements = () => {
    const selectedProjectId = sessionStorage.getItem('selectedProjectId');
    const selectedProjectname = sessionStorage.getItem('selectedProjectname');

  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [data, setData] = useState([]);
  const [showaddrequirementModal, setshowaddrequirementModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { password, username } = billpunchbasicauth;
  const getProjects = async (e) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        projectid: selectedProjectId,
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetProjectGatherings`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };
  const openaddprojectModal = () => {
    setshowaddrequirementModal(true);
  };

  const closeaddprojectModal = () => {
    setshowaddrequirementModal(false);
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  useEffect(() => {
    getProjects();
  }, []);
  const { accessData } = useContext(GlobalContext);
  useEffect(() => {
    console.log("Access Data:", accessData);
  }, [accessData]);
  return (
    <>
      <AddProjectrequirementAdminModal
        show={showaddrequirementModal}
        closeModal={closeaddprojectModal}
        getProjects={getProjects}
      />
      <div className="mt-4">
        <div className=" row ">
          <h5 className="col  mb-sm-4 d-flex align-items-center ">
            {" "}
            Requirements of {selectedProjectname}
          </h5>

          <div className=" col-6  d-flex justify-content-end">
            <div className="px-2 d-flex justify-content-end">
              <Form.Control
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange} style={{height:"2.3rem"}}
              />
            </div>{" "}
            <div className="px-2">
            <Button variant="success"
              className="btn  btn-sm  justify-content-center align-items-center"
              style={{
                borderRadius: ".4em",
                height: "2.5em",
                width: "11vw",
                border: "None",
              }}
              onClick={openaddprojectModal}
            >
              Add Requirements
            </Button>
            </div>
          
            <Link to="/admin/Createproject">
            <Button variant="info"
              className="btn  btn-sm justify-content-center align-items-center"
              style={{
                borderRadius: ".4em",
                height: "2.5em",
                // width: "8rem",
                border: "None",
              }}
            >
          Back
            </Button>
            </Link>
          
          </div>
        </div>

        <div
          className=" p-0 "
          style={{
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
          }}
        >
          <ViewProjectrequirementadmin
            data={data}
            searchTerm={searchTerm}
            getProjects={getProjects}
          />
        </div>
      </div>
    </>
  );
};

export default Requirements;
